import React, { useEffect } from 'react'
import CssBaseline from '@mui/material/CssBaseline'
import Routes, { routes } from './routes'
import { EventBusProvider } from '@emerald-works/react-event-bus-client'
import { useTenant, ApplicationAuth } from '@emerald-works-nova/auth'
import { EventContextProvider } from './hooks/useEventContext'
import { FreeAccountCtaModal } from './components'
import AlertProvider from './components/alert/provider'
import { SEOProvider } from './components/seo-context'
import { userCookiesGenerated } from './reducers/user/event-bus'
import usePageTracking from './hooks/useGA'
import { useCleanCookies } from './hooks'
import Favicon from './components/favicon'
import { Helmet } from 'react-helmet'

const App = ({ onChangeMainColor }) => {
  const tenant = useTenant()
  usePageTracking()
  useCleanCookies()

  const trackEventBusState = (eventName, data) => {
    import('./libs/data-dog').then((datadogRum) => {
      datadogRum?.default.addAction(eventName, data)
      console.log(`Connection ${eventName} hook with state: ${data}`)
    })
  }

  useEffect(() => {
    if (tenant && tenant.mainColor) {
      onChangeMainColor(tenant.mainColor)
    }
  }, [tenant, onChangeMainColor])

  return (
    <>
      <Helmet>
        <meta name='prerender-status-code' content='200' />
      </Helmet>
      <ApplicationAuth
        loginRoute={routes.login.path}
        tenant={tenant}
        authOptions={{ authenticationFlowType: 'USER_PASSWORD_AUTH' }}
      >
        <EventBusProvider
          eventBusURL={process.env.REACT_APP_EVENT_BUS_URL}
          connectionParams={{
            tenantKey: tenant?.tenantKey || 'admin'
          }}
          initialisers={[
            userCookiesGenerated
          ]}
          options={{
            socketIoUrl: process.env.REACT_APP_EVENT_BUS_BACKUP_URL || 'https://socketio.ewnova.dev'
          }}
          useAuthProvider
          fetchUserProfile
          namespace='toolkit'
          onConnectionChange={status => trackEventBusState('onConnectionChange', status)}
          onOpen={data => trackEventBusState('onOpen', data)}
          onClose={data => trackEventBusState('onClose', data)}
          onReconnect={data => trackEventBusState('onReconnect', data)}
          onMaximum={data => trackEventBusState('onMaximum', data)}
          onError={data => trackEventBusState('onError', data)}
        >
          <EventContextProvider>
            <SEOProvider>
              <Favicon />
              <CssBaseline />
              <FreeAccountCtaModal />
              <AlertProvider>
                <Routes />
              </AlertProvider>
            </SEOProvider>
          </EventContextProvider>
        </EventBusProvider>
      </ApplicationAuth>
    </>
  )
}
export default App
